var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcMessage(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "27px",
    height: "26px",
    viewBox: "0 0 27 26",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icMessage") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Interested-in-this-event-options-scenerio1",
    transform: "translate(-24.000000, -486.000000)",
    stroke: "#333333"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-13",
    transform: "translate(8.000000, 471.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(17.000000, 16.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.4833815,24.0384615 C19.410652,24.0384615 19.3379225,24.017682 19.2750776,23.9768359 L13.2090863,20.0490959 L13.1938953,20.049809 C12.9636373,20.0617266 12.7341077,20.0742555 12.5,20.0742555 C5.37344865,20.0742555 -1.0658141e-14,15.7593438 -1.0658141e-14,10.0375352 C-1.0658141e-14,4.31491169 5.37344865,-2.78888024e-13 12.5,-2.78888024e-13 C19.6265514,-2.78888024e-13 25,4.31491169 25,10.0375352 C25,13.740571 23.1781216,16.6960527 19.8621158,18.3840846 L19.8621158,23.6675875 C19.8621158,23.8033676 19.7856406,23.929369 19.6628641,23.9939485 C19.6068863,24.0235899 19.5447697,24.0384615 19.4833815,24.0384615 Z M6.31868132,11.5384615 C7.15317751,11.5384615 7.82967033,10.8927184 7.82967033,10.0961538 C7.82967033,9.2995893 7.15317751,8.65384615 6.31868132,8.65384615 C5.48418513,8.65384615 4.80769231,9.2995893 4.80769231,10.0961538 C4.80769231,10.8927184 5.48418513,11.5384615 6.31868132,11.5384615 Z M12.5,11.5384615 C13.3344962,11.5384615 14.010989,10.8927184 14.010989,10.0961538 C14.010989,9.2995893 13.3344962,8.65384615 12.5,8.65384615 C11.6655038,8.65384615 10.989011,9.2995893 10.989011,10.0961538 C10.989011,10.8927184 11.6655038,11.5384615 12.5,11.5384615 Z M18.6813187,11.5384615 C19.5158149,11.5384615 20.1923077,10.8927184 20.1923077,10.0961538 C20.1923077,9.2995893 19.5158149,8.65384615 18.6813187,8.65384615 C17.8468225,8.65384615 17.1703297,9.2995893 17.1703297,10.0961538 C17.1703297,10.8927184 17.8468225,11.5384615 18.6813187,11.5384615 Z",
    id: "icMessage"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMessage);
export default __webpack_public_path__ + "static/media/icMessage.0bce44f0966dccdbf9123913ed7ea103.svg";
export { ForwardRef as ReactComponent };